import './stylesheets/VideoThumbnail.css';

function VideoThumbnail(props) {
    const handleThumbnailClick = () => {
        const player = document.getElementById('VideoPlayer') || document.getElementById('VideoPlayer-Active');
        
        if (player) {
            player.id = player.id === 'VideoPlayer' ? 'VideoPlayer-Active' : 'VideoPlayer';
        } else {
            console.log('error, no video player');
        }

        if (props.setNowPlaying) {
            props.setNowPlaying(props);
        }
    }
    
    return (
        <div className="VideoThumbnail" onClick={handleThumbnailClick}>
            {props.platform}
            
            <div className="VideoThumbnail_image">
                <img src={props.thumbnailUrl} alt="Thumbnail" />
            </div>
            
            <div className="VideoThumbnail_info">
                <div className="VideoThumbnail_info_title">
                    {props.title}
                </div>
                
                <div className="VideoThumbnail_info_description">
                    {props.description}
                </div>
            </div>
        </div>
    );
}

export default VideoThumbnail;

